import VueRouter from 'vue-router';
import { localStorageService } from 'views/components/crm/api/localStorageService';

Vue.use(VueRouter);

const HOME_PATH = '/';
const LOGIN_PATH = '/login';

// Normaliza rutas removiendo el prefijo '/'
function normalizePath(path) {
  if (!path) return '';
  return String(path).split('?')[0].split('#')[0].replace(/^\//, '');
}

function handleLoginPath(to) {
  if (to.path === LOGIN_PATH) {
    localStorageService.destruirSesion();
  }
}

function getPermisos() {
  const raw = localStorage.getItem('permisos');
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.pages)) {
      return { pages: [] };
    }
    return parsed;
  } catch (e) {
    return { pages: [] };
  }
}

function hasAccessToPage(permisos, toPath) {
  const pageKey = normalizePath(toPath);
  if (pageKey === '') return true; // HOME siempre accesible
  return permisos && Array.isArray(permisos.pages)
    ? permisos.pages.includes(pageKey)
    : true; // si no hay estructura clara, no bloquear
}

const router = new VueRouter({
  base: 'website',
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/solicitudes/:status?',
      component: () => import('views/components/crm/views/lista_solicitudes.vue'),
    },
    {
      path: '/detalle_solicitud/:id_crm?',
      component: () => import('views/components/crm/views/detalle_solicitud.vue'),
    },
    {
      path: '/galeria_imagenes',
      component: () =>
        import('views/components/crm/components/sitio_web/galeria_imagenes.vue'),
    },
    {
      path: '/seo',
      component: () => import('views/components/crm/components/sitio_web/seo.vue'),
    },
    {
      path: '/preguntas-frecuentes',
      component: () =>
        import('views/components/crm/components/sitio_web/preguntas_frecuentes.vue'),
    },
    {
      path: '/',
      component: () => import('views/components/crm/components/sitio_web/pagina.vue'),
      name: 'home',
    },
    {
      path: '/login',
      component: () => import('views/components/crm/views/login.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  handleLoginPath(to);

  const sesionActiva = localStorageService.isSessionActive();

  // Redirecciones de autenticación
  if (!sesionActiva && to.path !== LOGIN_PATH) {
    return next(LOGIN_PATH);
  }
  if (sesionActiva && to.path === LOGIN_PATH) {
    return next(HOME_PATH);
  }
  if (!sesionActiva && to.path === LOGIN_PATH) {
    return next();
  }

  // Control de permisos
  const permisos = getPermisos();
  if (!permisos) {
    return next();
  }

  if (!hasAccessToPage(permisos, to.path)) {
    return next(HOME_PATH);
  }

  return next();
});

export default router;
